(function () {
    function getMsgBox(form) {
      var box = form.querySelector('.ajax-form-msg');
      if (!box) {
        box = document.createElement('div');
        box.className = 'ajax-form-msg';
        box.style.cssText = 'margin:10px 0;font-size:13px;line-height:1.4;display:none;';
        form.insertBefore(box, form.firstChild);
      }
      return box;
    }

    function showMsg(form, text, type) {
      var box = getMsgBox(form);
      if (!text) { box.style.display = 'none'; box.textContent = ''; return; }
      box.textContent = text;
      box.style.color = (type === 'success') ? '#428445' : '#EB001B';
      box.style.display = 'block';
    }

    function errorFromHtml(html) {
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var selectors = ['.errors li', '.errors', '.form__message', '[id$="-error"]', '.form-message--error', '.errors p'];
        for (var i = 0; i < selectors.length; i++) {
          var el = doc.querySelector(selectors[i]);
          if (el && el.textContent.trim()) {
            return el.textContent.trim().replace(/\s+/g, ' ');
          }
        }
      } catch (e) {}
      return '';
    }

    function bindAjax(form, opts) {
      if (!form) return;
      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        // Custom pre-validation (e.g. 18+ age check). Agar false return ho to submit roko.
        if (opts.validate && !opts.validate(form)) { return; }

        if (!form.checkValidity || !form.checkValidity()) { form.reportValidity && form.reportValidity(); return; }

        var btn = form.querySelector('button[type="submit"], button.submit_btn_new');
        var oldHtml = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = 'Please wait...'; }
        showMsg(form, '', 'error');

        try {
          var res = await fetch(form.getAttribute('action'), {
            method: 'POST',
            body: new URLSearchParams(new FormData(form)),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          if (opts.type === 'recover') {
            showMsg(form, opts.successMsg, 'success');
            if (btn) { btn.disabled = false; btn.innerHTML = oldHtml; }
            return;
          }

          if (res.redirected && res.url.indexOf('/account/login') === -1 && res.url.indexOf('/account/register') === -1) {
            window.location.href = res.url;
            return;
          }

          var html = await res.text();
          showMsg(form, errorFromHtml(html) || opts.errorMsg, 'error');
          if (btn) { btn.disabled = false; btn.innerHTML = oldHtml; }
        } catch (err) {
          showMsg(form, 'Something went wrong. Please try again.', 'error');
          if (btn) { btn.disabled = false; btn.innerHTML = oldHtml; }
        }
      });
    }

    // 18+ age validation (submit ke time, reliable)
    function validateAge(form) {
      var dob = form.querySelector('#RegisterForm-dateofbirth');
      if (!dob || !dob.value) return true;

      var t = new Date();
      var b = new Date(dob.value + 'T00:00:00');
      var age = t.getFullYear() - b.getFullYear();
      var m = t.getMonth() - b.getMonth();
      if (m < 0 || (m === 0 && t.getDate() < b.getDate())) age--;

      // Message ko gender (.custom-select) ke baad insert karo
      var genderField = form.querySelector('.custom-select');
      var msg = form.querySelector('.dob-age-error');
      if (!msg) {
        msg = document.createElement('span');
        msg.className = 'dob-age-error';
        msg.style.cssText = 'color:#EB001B;font-size:12px;margin-top:0px;display:none;';
        msg.textContent = 'You must be at least 18 years old to register.';
        if (genderField) {
          genderField.insertAdjacentElement('afterend', msg);
        } else {
          (dob.closest('.Dateofbirth') || dob.parentElement).appendChild(msg);
        }
      }

      if (age < 18) {
        msg.style.display = 'block';
        dob.classList.add('input-error');
        dob.focus();
        return false;
      }
      msg.style.display = 'none';
      dob.classList.remove('input-error');
      return true;
    }

    document.addEventListener('DOMContentLoaded', function () {
      var popup = document.querySelector('#customerPopup');
      if (!popup) return;

      bindAjax(popup.querySelector('#login form'), {
        type: 'login',
        errorMsg: 'Incorrect email or password. Please try again.'
      });
      bindAjax(popup.querySelector('#sign-up form'), {
        type: 'register',
        errorMsg: 'Could not create the account. Please check your details.',
        validate: validateAge
      });
      bindAjax(popup.querySelector('#recover form'), {
        type: 'recover',
        successMsg: "If an account exists for this email, we've sent a password reset link."
      });
    });
  })();


(function () {
    var popup = document.querySelector('#customerPopup');
    if (!popup) return;
    var dob = popup.querySelector('#RegisterForm-dateofbirth');
    if (!dob) return;
    var form = dob.closest('form');
    if (!form) return;

    function getAge() {
      var b = dob.valueAsDate;
      if ((!b || isNaN(b.getTime())) && dob.value) {
        var p = dob.value.split(/[-/]/);
        if (p.length === 3) b = new Date(Date.UTC(+p[0], +p[1]-1, +p[2]));
      }
      if (!b || isNaN(b.getTime())) return null;
      var t = new Date();
      var age = t.getFullYear() - b.getUTCFullYear();
      var m = t.getMonth() - b.getUTCMonth();
      if (m < 0 || (m === 0 && t.getDate() < b.getUTCDate())) age--;
      return age;
    }

    function getMsg() {
      var genderField = form.querySelector('.custom-select');
      var msg = form.querySelector('.dob-age-error');
      if (!msg) {
        msg = document.createElement('span');
        msg.className = 'dob-age-error';
        msg.style.cssText = 'color:#EB001B;font-size:12px;margin-top:0px;display:none;';
        msg.textContent = 'You must be at least 18 years old to register.';
        if (genderField) genderField.insertAdjacentElement('afterend', msg);
        else (dob.closest('.Dateofbirth') || dob.parentElement).appendChild(msg);
      }
      return msg;
    }

    function liveValidate() {
      var age = getAge();
      var msg = getMsg();
      if (age !== null && age < 18) {
        msg.style.display = 'block';
        dob.classList.add('input-error');
      } else {
        msg.style.display = 'none';
        dob.classList.remove('input-error');
      }
    }

    dob.addEventListener('change', liveValidate);
    dob.addEventListener('input', liveValidate);
  })();




//custom select dropdown start
document.addEventListener("DOMContentLoaded", function () {
      
      var x, i, j, l, ll, selElmnt, a, b, c;
      /* Look for any elements with the class "custom-select": */
      x = document.getElementsByClassName("custom-select");
      l = x.length;
      for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        /* For each element, create a new DIV that will act as the selected item: */
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /* For each element, create a new DIV that will contain the option list: */
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 1; j < ll; j++) {
          /* For each option in the original select element,
          create a new DIV that will act as an option item: */
          c = document.createElement("DIV");
          c.innerHTML = selElmnt.options[j].innerHTML;
          c.addEventListener("click", function(e) {
              /* When an item is clicked, update the original select box,
              and the selected item: */
              var y, i, k, s, h, sl, yl;
              s = this.parentNode.parentNode.getElementsByTagName("select")[0];
              sl = s.length;
              h = this.parentNode.previousSibling;
              for (i = 0; i < sl; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                  s.selectedIndex = i;
                  h.innerHTML = this.innerHTML;
                  y = this.parentNode.getElementsByClassName("same-as-selected");
                  yl = y.length;
                  for (k = 0; k < yl; k++) {
                    y[k].removeAttribute("class");
                  }
                  this.setAttribute("class", "same-as-selected");
                  break;
                }
              }
              h.click();
          });
          b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function(e) {
          /* When the select box is clicked, close any other select boxes,
          and open/close the current select box: */
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
        });
      }
      
      function closeAllSelect(elmnt) {
        /* A function that will close all select boxes in the document,
        except the current select box: */
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i)
          } else {
            y[i].classList.remove("select-arrow-active");
          }
        }
        for (i = 0; i < xl; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
          }
        }
      }
      /* If the user clicks anywhere outside the select box,
      then close all select boxes: */
      document.addEventListener("click", closeAllSelect);
      
    });
//custom select dropdown close


  const customSignUpInput = document.querySelector("#RegisterForm-number");
  setTimeout(() => {
    window.intlTelInput(customSignUpInput, {
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@20.3.0/build/js/utils.js",
      showFlags: true,
      phone: "phone_full",
      country: "country_code",
      showSelectedDialCode: true,
      initialCountry: 'gb',
      separateDialCode: true,
    });
  }, 2000)

 
  customSignUpInput.addEventListener('change', function() {
    const dialCode = window.intlTelInputGlobals.getInstance(customSignUpInput).getSelectedCountryData().dialCode
    const countryCode = document.querySelector('#countryCode');
    countryCode.value = dialCode
  })

  